export default __webpack_public_path__ + "static/media/dna6.162a20c0.png";